import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0cdc8c49")

_pushScopeId("data-v-0cdc8c49")
const _hoisted_1 = { class: "hero pink-background block" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container is-fluid container-fullwidth" }
const _hoisted_4 = { class: "level" }
const _hoisted_5 = { class: "level-left" }
const _hoisted_6 = { class: "level-item" }
const _hoisted_7 = {
  key: 0,
  class: "field"
}
const _hoisted_8 = { class: "control is-expanded" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Product", -1)
const _hoisted_10 = { class: "select" }
const _hoisted_11 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: ""
}, "Select a product", -1)
const _hoisted_12 = {
  key: 0,
  class: "level-item"
}
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "control" }
const _hoisted_15 = { class: "checkbox" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Enable Edit Options ")
const _hoisted_17 = { class: "level-right" }
const _hoisted_18 = { class: "level-item" }
const _hoisted_19 = { class: "field is-flex is-justify-content-right" }
const _hoisted_20 = { class: "control buttons" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "field mb-4"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Hide UI Elements", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "help mb-2" }, " These settings are used in case the external app wants to control certain actions from Infigo ", -1)
const _hoisted_25 = { class: "control" }
const _hoisted_26 = { class: "checkbox" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Hide add to basket button ")
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "field mb-4" }, [
  /*#__PURE__*/_createVNode("label", { class: "label" }, "Product Attributes"),
  /*#__PURE__*/_createVNode("p", { class: "help" }, " These product attributes are loaded from Infigo. The values set will be reflected in Infigo. ")
], -1)
const _hoisted_30 = { class: "control" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = {
  key: 1,
  class: "checkboxes"
}
const _hoisted_33 = {
  key: 2,
  class: "select"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: ""
}, "Select a value", -1)
const _hoisted_35 = {
  key: 3,
  class: "radio-list"
}
const _hoisted_36 = {
  key: 1,
  class: "iframe"
}
const _hoisted_37 = {
  key: 0,
  class: "notification is-info is-light mb-4"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "is-size-7 mb-2" }, [
  /*#__PURE__*/_createVNode("strong", null, "External App Control Mode:"),
  /*#__PURE__*/_createTextVNode(" The selected buttons are hidden inside the Infigo editor, allowing your external application to control these actions. ")
], -1)
const _hoisted_39 = {
  key: 0,
  class: "is-size-7"
}
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<p class=\"mb-1\" data-v-0cdc8c49><strong data-v-0cdc8c49>Add to Basket Flow:</strong></p><ol class=\"ml-4 mb-2\" style=\"list-style-type:decimal;\" data-v-0cdc8c49><li data-v-0cdc8c49>Wait for <code data-v-0cdc8c49>Infigo.JobChanged</code> event with <code data-v-0cdc8c49>isCompleted: true</code></li><li data-v-0cdc8c49>Your external app calls <code data-v-0cdc8c49>CatfishEditorCommunication.PostMessage()</code> with: <ul class=\"ml-4 mt-1\" style=\"list-style-type:disc;\" data-v-0cdc8c49><li data-v-0cdc8c49><strong data-v-0cdc8c49>messageId:</strong> <code data-v-0cdc8c49>&#39;Infigo.ItemAddedToBasketFromIframe&#39;</code></li><li data-v-0cdc8c49><strong data-v-0cdc8c49>data:</strong> No data object to be sent</li><li data-v-0cdc8c49><strong data-v-0cdc8c49>target_url:</strong> <code data-v-0cdc8c49>&#39;{protocol}://{host}&#39;</code> (iframe domain)</li><li data-v-0cdc8c49><strong data-v-0cdc8c49>target:</strong> <code data-v-0cdc8c49>iframeElement.contentWindow</code></li></ul></li><li data-v-0cdc8c49>Infigo responds with <code data-v-0cdc8c49>Infigo.ItemAddedToBasket</code> event containing job details</li></ol><p class=\"mb-0\" data-v-0cdc8c49><strong data-v-0cdc8c49>Example:</strong></p><pre class=\"has-background-dark has-text-light p-2 is-size-7\" style=\"border-radius:4px;overflow-x:auto;\" data-v-0cdc8c49>CatfishEditorCommunication.PostMessage(\n  &#39;Infigo.ItemAddedToBasketFromIframe&#39;,\n  &#39;&#39;,\n  &#39;https://your-infigo-domain.com&#39;,\n  document.getElementById(&#39;infigo-iframe&#39;).contentWindow\n);</pre>", 4)
const _hoisted_44 = {
  key: 1,
  class: "field mb-4"
}
const _hoisted_45 = { class: "control buttons" }
const _hoisted_46 = {
  key: 2,
  class: "iframe"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_InfigoIframe = _resolveComponent("InfigoIframe")
  const _component_InfigoLoading = _resolveComponent("InfigoLoading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, { subtitle: "Explore our Editor Iframe, choose a product" }),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock("form", {
                key: 0,
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openIframeSubmit && _ctx.openIframeSubmit(...args)), ["prevent"])),
                id: "iframe-form"
              }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      (!_ctx.canGoToBasket)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, [
                            _createVNode("div", _hoisted_8, [
                              _hoisted_9,
                              _createVNode("div", _hoisted_10, [
                                _withDirectives(_createVNode("select", {
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.iframeProductId = $event)),
                                  required: "",
                                  onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onProductChanged($event.target.value)))
                                }, [
                                  _hoisted_11,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                                    return (_openBlock(), _createBlock("option", {
                                      key: product.id,
                                      value: product.id
                                    }, _toDisplayString(product.name), 9, ["value"]))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, _ctx.iframeProductId]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.canGoToBasket)
                      ? (_openBlock(), _createBlock("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("label", _hoisted_15, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.enableEditOptions = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.enableEditOptions]
                                ]),
                                _hoisted_16
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          (!_ctx.canGoToBasket && _ctx.canDesign())
                            ? (_openBlock(), _createBlock("button", {
                                key: 0,
                                type: "submit",
                                class: "button is-dark-infigo",
                                disabled: !_ctx.iframeProductId
                              }, " Open Editor ", 8, ["disabled"]))
                            : _createCommentVNode("", true),
                          (!_ctx.canGoToBasket && _ctx.canDesign())
                            ? (_openBlock(), _createBlock("button", {
                                key: 1,
                                type: "button",
                                class: "button is-dark-infigo",
                                disabled: !_ctx.iframeProductId,
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openLandingPage && _ctx.openLandingPage(...args)))
                              }, " Open Landing Page ", 8, ["disabled"]))
                            : _createCommentVNode("", true),
                          (!_ctx.canGoToBasket && !_ctx.canDesign())
                            ? (_openBlock(), _createBlock("button", {
                                key: 2,
                                type: "button",
                                class: "button is-dark-infigo",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addToBasket && _ctx.addToBasket(...args)))
                              }, " Add to basket "))
                            : _createCommentVNode("", true),
                          _createVNode("button", {
                            type: "button",
                            class: "button is-dark-infigo",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/shopping-list')))
                          }, " Go to basket ")
                        ])
                      ])
                    ])
                  ])
                ]),
                (!_ctx.canGoToBasket)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      (_ctx.isMultipartOrMegaEditProduct)
                        ? (_openBlock(), _createBlock("div", _hoisted_22, [
                            _hoisted_23,
                            _hoisted_24,
                            _createVNode("div", _hoisted_25, [
                              _createVNode("label", _hoisted_26, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideAddToBasketButton = $event))
                                }, null, 512), [
                                  [_vModelCheckbox, _ctx.hideAddToBasketButton]
                                ]),
                                _hoisted_27
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getAttributes().length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_28, [
                            _hoisted_29,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getAttributes(), (attr) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "attribute",
                                key: attr.name
                              }, [
                                _createVNode("div", _hoisted_30, [
                                  _createVNode("label", _hoisted_31, _toDisplayString(attr.name), 1),
                                  (attr.type == _ctx.attributeTypes.TextBox)
                                    ? (_openBlock(), _createBlock("input", {
                                        key: 0,
                                        class: "input",
                                        type: "text",
                                        placeholder: attr.description,
                                        onInput: ($event: any) => (_ctx.onAttributeChanged(attr.name, $event.target.value))
                                      }, null, 40, ["placeholder", "onInput"]))
                                    : (attr.type == _ctx.attributeTypes.Checkboxes)
                                      ? (_openBlock(), _createBlock("div", _hoisted_32, [
                                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(attr.values, (value) => {
                                            return (_openBlock(), _createBlock("label", {
                                              class: "checkbox",
                                              key: value.id
                                            }, [
                                              _createVNode("input", {
                                                type: "checkbox",
                                                value: value.name,
                                                onChange: ($event: any) => (_ctx.onAttributeChanged(attr.name, $event.target.value))
                                              }, null, 40, ["value", "onChange"]),
                                              _createTextVNode(" " + _toDisplayString(value.name), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      : (attr.type == _ctx.attributeTypes.DropdownList)
                                        ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                            _createVNode("select", {
                                              onChange: ($event: any) => (_ctx.onAttributeChanged(attr.name, $event.target.value))
                                            }, [
                                              _hoisted_34,
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(attr.values, (value) => {
                                                return (_openBlock(), _createBlock("option", {
                                                  key: value.id,
                                                  value: value.name
                                                }, _toDisplayString(value.name), 9, ["value"]))
                                              }), 128))
                                            ], 40, ["onChange"])
                                          ]))
                                        : (attr.type == _ctx.attributeTypes.RadioList)
                                          ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(attr.values, (value) => {
                                                return (_openBlock(), _createBlock("label", {
                                                  class: "radio",
                                                  key: value.id
                                                }, [
                                                  _createVNode("input", {
                                                    type: "radio",
                                                    value: value.name,
                                                    name: attr.name,
                                                    onChange: ($event: any) => (_ctx.onAttributeChanged(attr.name, $event.target.value))
                                                  }, null, 40, ["value", "name", "onChange"]),
                                                  _createTextVNode(" " + _toDisplayString(value.name), 1)
                                                ]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock("input", {
                                              key: 4,
                                              class: "input",
                                              type: "text",
                                              placeholder: attr.description,
                                              onInput: ($event: any) => (_ctx.onAttributeChanged(attr.name, $event.target.value))
                                            }, null, 40, ["placeholder", "onInput"]))
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.openIframe)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                (_ctx.showExternalButtons && !_ctx.itemAddedToBasket)
                  ? (_openBlock(), _createBlock("div", _hoisted_37, [
                      _hoisted_38,
                      (_ctx.hideAddToBasketButton)
                        ? (_openBlock(), _createBlock("div", _hoisted_39, [
                            _hoisted_40
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showExternalButtons)
                  ? (_openBlock(), _createBlock("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        (_ctx.hideAddToBasketButton && !_ctx.itemAddedToBasket)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              type: "button",
                              class: "button is-dark-infigo",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleExternalAddToBasket && _ctx.handleExternalAddToBasket(...args))),
                              disabled: !_ctx.isJobCompleted
                            }, " Add to Basket ", 8, ["disabled"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_InfigoIframe, {
                  "product-id": _ctx.iframeProductId,
                  onIframeLoaded: _ctx.iframeLoaded,
                  attributes: _ctx.attributeSelection,
                  "enable-edit-options": _ctx.enableEditOptions,
                  onItemAddedToBasket: _ctx.addDesignJob,
                  "hide-elements": _ctx.getHideElements(),
                  onJobChanged: _ctx.onJobChanged,
                  ref: "infigoIframe"
                }, null, 8, ["product-id", "onIframeLoaded", "attributes", "enable-edit-options", "onItemAddedToBasket", "hide-elements", "onJobChanged"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.landingPageSrc)
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                _createVNode("iframe", {
                  id: "landing-page-iframe",
                  width: "100%",
                  height: "800px",
                  scrolling: "no",
                  frameborder: "0",
                  class: "infigo-main-editor is-clipped",
                  src: _ctx.landingPageSrc
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_InfigoLoading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
})